import { html, TemplateResult } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTISPAM_RULES_FORM } from '../../../../../../../../../../webcomponents.constants';
import { GzPolicyFullPageWindowFormWebComponent } from '../../../../../../../../../common/policyPanel/uiSettings/dialogs/fullPage/form';
import { ExchangeAntispamRuleFormValue } from '../../../../../../../utils/uiSettings/exchange/exchange-protection.types';
import _ from 'lodash';
import { GzFormFieldWebComponent } from '../../../../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { GzInputNumberWebComponent, InputWidthValues } from '../../../../../../../../../../ui/gzInput';
import { GzCheckboxWebComponent } from '../../../../../../../../../../ui/gzCheckbox';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { FormGroup } from '../../../../../../../../../../ui/gzForm/formGroup/form-group';
import { GzHardCodedFormField } from '../../../../../../../../../../ui/gzForm/formField/component/GzHardCodedFormField';
import { toggleDisabled, toggleVisibility } from '../../../../../../../../../../utils/htmlElement.utils';
import { GzDropdownWebComponent } from '../../../../../../../../../../ui/gzDropdown';
import { GzRadioGroupWebComponent } from '../../../../../../../../../../ui/gzRadio';
import { GzExchangeUserGroupsGridWebComponent } from '../../../../../helpers/gridComponents/userGroupsWithSelection/GzExchangeUserGroupsGridWebComponent';
import {
  ExchangeAntispamAggressivity,
  ExchangeAntispamRuleActionType,
  ExchangeRuleScopeApplyToType,
  ExchangeRuleScopeEmailSelection,
} from '@nirvana/shared/dtos/types/policies/common';
import {
  getExchangeAntispamActionRuleFormOptions,
  getExchangeAntispamAggressivity,
  getExchangeApplyToRuleFormOptions,
} from '../../../../../../../utils/uiSettings/exchange/exchange-protection.values';
import { FontSizes, FontWeights } from 'apps/webcomponents/src/types/common/types';
import { ruleScopeSpecificValidators } from '../../../../../antimalware/gridComponents/filteringRules/rulesItemForm/utils/validators';
import { GzSelectionCardGroupWebComponent } from '../../../../../../../../../../ui/gzSelectionCardGroup';
import { EmailValidator } from '../../../../../../../../../../ui/gzForm/validators/email.validator';
import { CustomizableValidator } from '../../../../../../../../../../ui/gzForm/validators/customizable.validator';
import { validateHeaderName, validateMultipleEmails, validatePathWin } from '../../../../../helpers/utils/validators';
import { ValidationResult } from '../../../../../../../../../../ui/gzForm/formField/types/form-validator';

/**
 * @summary Type here the description of this component
 * @tag rulesItemForm
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement(WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTISPAM_RULES_FORM)
export class GzExchangeAntispamRulesFormWebComponent extends GzPolicyFullPageWindowFormWebComponent<ExchangeAntispamRuleFormValue> {
  // general section
  @query('#name')
  private ruleName: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#priority')
  private rulePriority: GzFormFieldWebComponent<GzInputNumberWebComponent, number>;
  @query('#active-form-field')
  private activeFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;

  // scope section
  @query('#rule-scope-apply-to-field')
  private ruleScopeApplyToField: GzFormFieldWebComponent<GzDropdownWebComponent>;
  @query('#rule-scope-from-field')
  private ruleScopeFromField: GzFormFieldWebComponent<GzRadioGroupWebComponent>;
  @query('#rule-scope-from-specific-field')
  private ruleScopeFromSpecificField: GzFormFieldWebComponent<GzExchangeUserGroupsGridWebComponent>;
  @query('#rule-scope-to-field')
  private ruleScopeToField: GzFormFieldWebComponent<GzRadioGroupWebComponent>;
  @query('#rule-scope-to-specific-field')
  private ruleScopeToSpecificField: GzFormFieldWebComponent<GzExchangeUserGroupsGridWebComponent>;
  @query('#rule-scope-match-all-recipients-field')
  private ruleScopeMatchAllRecipientsField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#asian-field')
  private asianFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#cyrilic-field')
  private cyrillicFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#fapMaterial-field')
  private fapMaterialFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#url-field')
  private urlFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#rbl-field')
  private rblFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#heuristic-field')
  private heuristicFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#cloud-field')
  private cloudFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#auth-connections-check-field')
  private authConnectionsCheckField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;

  // aggressivity
  @query('#aggressivity-field')
  private aggressivityField: GzFormFieldWebComponent<GzSelectionCardGroupWebComponent>;

  // action section
  @query('#rule-actions-type-field')
  private ruleActionsTypeField: GzFormFieldWebComponent<GzDropdownWebComponent>;
  @query('#rule-actions-deliver-to-field')
  private ruleActionsDeliverToField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#rule-actions-modify-subject-field')
  private ruleActionsModifySubjectField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#rule-actions-modify-subject-text-field')
  private ruleActionsModifySubjectTextField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#rule-actions-append-header-field')
  private ruleActionsAppendHeaderField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#rule-actions-append-header-name-field')
  private ruleActionsAppendHeaderNameField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#rule-actions-append-header-value-field')
  private ruleActionsAppendHeaderValueField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#rule-actions-save-mail-to-disk-field')
  private ruleActionsSaveMailToDiskField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#rule-actions-save-mail-to-disk-path-field')
  private ruleActionsSaveMailToDiskPathField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#rule-actions-archive-to-account-field')
  private ruleActionsArchiveToAccountField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#rule-actions-archive-to-account-address-field')
  private ruleActionsArchiveToAccountAddressField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#rules-actions-notify-section')
  private ruleActionsNotifySection: HTMLElement;
  @query('#rule-actions-notify-recipient-field')
  private ruleActionsNotifyRecipientField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#rule-actions-notify-sender-field')
  private ruleActionsNotifySenderField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#rule-actions-notify-account-field')
  private ruleActionsNotifyAccountField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#rule-actions-notify-account-recipients-field')
  private ruleActionsNotifyAccountRecipientsField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#rule-actions-stop-if-matched-field')
  private ruleActionsStopIfMatchedField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#exchange-scl-field')
  private rulesActionsExchangeSclField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;

  public constructor(
    private readonly maxPriority: number,
    private readonly ruleNames: string[],
    value?: ExchangeAntispamRuleFormValue
  ) {
    super(value);
    this.maxPriority = maxPriority;
    this.ruleNames = ruleNames;
  }

  static get styles() {
    return styles;
  }

  public setError(error: string) {
    this.ruleName.setError(error);
  }

  protected getConvertedFormValue() {
    const value = _.cloneDeep(this.formGroup.value);

    if (
      ![ExchangeAntispamRuleActionType.DELIVER, ExchangeAntispamRuleActionType.REDIRECT].includes(
        _.get(this.formGroup.value, ['actions', 'type'], ExchangeAntispamRuleActionType.DELIVER)
      )
    ) {
      _.set(value, ['actions', 'modifySubject'], false);
      _.set(value, ['actions', 'modifySubjectText'], '');
    }

    // set modifiy subject (by default false if missing)
    const modifySubject = _.get(this.formGroup.value, ['actions', 'modifySubject'], false);
    _.set(value, ['actions', 'modifySubject'], modifySubject);

    // set archive to account (by default false if missing)
    const archiveToAccount = _.get(this.formGroup.value, ['actions', 'archiveToAccount'], false);
    _.set(value, ['actions', 'archiveToAccount'], archiveToAccount);

    // set append header (by default false if missing)
    const appendHeader = _.get(this.formGroup.value, ['actions', 'appendHeader'], false);
    _.set(value, ['actions', 'appendHeader'], appendHeader);

    return value;
  }

  private setValidators() {
    this.ruleName.Validators = [
      RequiredValidator(translateFn('Required field')),
      CustomizableValidator((value: string) => validateRuleName(value, this.ruleNames)),
    ];
    this.ruleActionsModifySubjectTextField.Validators = [RequiredValidator(translateFn('Required field'))];
    this.ruleActionsDeliverToField.Validators = [
      RequiredValidator(translateFn('Required field')),
      EmailValidator(translateFn('Invalid email address')),
    ];
    this.ruleActionsAppendHeaderNameField.Validators = [
      RequiredValidator(translateFn('Required field')),
      CustomizableValidator((value: string) => validateHeaderName(value)),
    ];
    this.ruleActionsAppendHeaderValueField.Validators = [RequiredValidator(translateFn('Required field'))];
    this.ruleActionsSaveMailToDiskPathField.Validators = [
      RequiredValidator(translateFn('Required field')),
      CustomizableValidator((value: string) => validatePathWin(value)),
    ];
    this.ruleActionsArchiveToAccountAddressField.Validators = [
      RequiredValidator(translateFn('Required field')),
      EmailValidator(translateFn('Invalid email address')),
    ];
    this.ruleActionsNotifyAccountRecipientsField.Validators = [
      RequiredValidator(translateFn('Required field')),
      CustomizableValidator((value: string) => validateMultipleEmails(value)),
    ];
  }

  protected createFormGroup(): void {
    this.setValidators();
    this.formGroup = FormGroup.build({
      defaultPositionInGrid: this.rulePriority,
      name: this.ruleName,
      active: this.activeFormField,
      default: new GzHardCodedFormField<boolean>(false),
      scope: {
        applyTo: this.ruleScopeApplyToField,
        from: this.ruleScopeFromField,
        to: this.ruleScopeToField,
        fromSpecific: this.ruleScopeFromSpecificField,
        toSpecific: this.ruleScopeToSpecificField,
        matchAllRecipients: this.ruleScopeMatchAllRecipientsField,
      },
      aggressivity: this.aggressivityField,
      filters: {
        asian: this.asianFormField,
        cyrillic: this.cyrillicFormField,
        fapMaterial: this.fapMaterialFormField,
        url: this.urlFormField,
        rbl: this.rblFormField,
        heuristic: this.heuristicFormField,
        cloud: this.cloudFormField,
      },
      checkAuthConnections: this.authConnectionsCheckField,
      actions: {
        type: this.ruleActionsTypeField,
        exchangeSCL: this.rulesActionsExchangeSclField,
        deliverTo: this.ruleActionsDeliverToField,
        modifySubject: this.ruleActionsModifySubjectField,
        modifySubjectText: this.ruleActionsModifySubjectTextField,
        appendHeader: this.ruleActionsAppendHeaderField,
        headerName: this.ruleActionsAppendHeaderNameField,
        headerValue: this.ruleActionsAppendHeaderValueField,
        saveMailToDisk: this.ruleActionsSaveMailToDiskField,
        saveMailToDiskPath: this.ruleActionsSaveMailToDiskPathField,
        archiveToAccount: this.ruleActionsArchiveToAccountField,
        archiveToAccountAddress: this.ruleActionsArchiveToAccountAddressField,
        stopIfMatched: this.ruleActionsStopIfMatchedField,
        notifyRecipient: this.ruleActionsNotifyRecipientField,
        notifySender: this.ruleActionsNotifySenderField,
        notifyAccount: this.ruleActionsNotifyAccountField,
        notifyAccountRecipients: this.ruleActionsNotifyAccountRecipientsField,
      },
    });
  }

  protected renderContent(): TemplateResult {
    return html`
      <div class="rules-form-container">
        <!-- General section -->
        <div id="rules-general-section">
          <gz-title fontWeight="500" fontSize="18" class="module-subtitle">${translateFn('General')}</gz-title>
          <gz-form-field id="name" class="label-mw-250" label="${translateFn('Rule name')}" required>
            <gz-input
              inputWidth="${InputWidthValues.LARGE}"
              gz-form-input
              placeholder="${translateFn('Enter the rule name')}"
            ></gz-input>
            <gz-input-error></gz-input-error>
          </gz-form-field>

          <gz-form-field id="priority" class="label-mw-250" label="${translateFn('Set priority')}" required>
            <gz-input-number
              gz-form-input
              inputWidth="${InputWidthValues.SMALL}"
              min="${1}"
              max="${this.maxPriority}"
            ></gz-input-number>
            <gz-input-error></gz-input-error>
          </gz-form-field>

          <gz-form-field id="active-form-field" class="mt-2">
            <gz-checkbox gz-form-input label="${translateFn('Active')}" checked></gz-checkbox>
          </gz-form-field>
        </div>
        <!-- Rule scope section -->
        <div id="rules-scope-section">
          <gz-title fontWeight="500" fontSize="18" class="module-subtitle mt-5">${translateFn('Rule scope')}</gz-title>
          <gz-form-field id="rule-scope-apply-to-field" label="${translateFn('Apply to (direction)')}">
            <gz-dropdown
              gz-form-input
              .options=${getExchangeApplyToRuleFormOptions()}
              .value=${ExchangeRuleScopeApplyToType.ALL}
            ></gz-dropdown>
          </gz-form-field>

          <gz-labeled-content
            hasFormLabelWidth
            hasColon
            labelFontSize="${FontSizes.HEADING_6}"
            labelFontWeight="${FontWeights.NORMAL}"
            label="${translateFn('Senders')}"
          >
            <gz-form-field id="rule-scope-from-field">
              <gz-radio-group
                gz-form-input
                .selectedOption=${ExchangeRuleScopeEmailSelection.ANY}
                @radioSelectionChanged=${this.handleScopeFromEmailSelectionChange.bind(this)}
              >
                <gz-radio
                  class="mr-7"
                  label="${translateFn('Any')}"
                  .value=${ExchangeRuleScopeEmailSelection.ANY}
                ></gz-radio>
                <gz-radio
                  label="${translateFn('Specific')}"
                  .value=${ExchangeRuleScopeEmailSelection.SPECIFIC}
                ></gz-radio>
              </gz-radio-group>
              <gz-input-error></gz-input-error>
            </gz-form-field>
          </gz-labeled-content>
          <gz-text
            id="rule-scope-from-description"
            fontSize="${FontSizes.PARAGRAPH_12}"
            fontWeight="${FontWeights.NORMAL}"
            class="infoText"
            .innerHTML=${translateFn(
              'By default, the rule applies to all senders. To apply different filtering settings and actions for certain sender groups, select {bold}Specific{/bold} and add a custom rule.',
              {
                bold: '<strong>',
                '/bold': '</strong>',
              }
            )}
          ></gz-text>

          <gz-form-field id="rule-scope-from-specific-field" class="hidden">
            <gz-policy-panel-exchange-user-groups-grid gz-form-input></gz-policy-panel-exchange-user-groups-grid>
            <gz-input-error></gz-input-error>
          </gz-form-field>

          <gz-labeled-content
            hasFormLabelWidth
            hasColon
            labelFontSize="${FontSizes.HEADING_6}"
            labelFontWeight="${FontWeights.NORMAL}"
            label="${translateFn('Recipients')}"
            class="mt-2"
          >
            <gz-form-field id="rule-scope-to-field">
              <gz-radio-group
                gz-form-input
                .selectedOption=${ExchangeRuleScopeEmailSelection.ANY}
                @radioSelectionChanged=${this.handleScopeToEmailSelectionChange.bind(this)}
              >
                <gz-radio
                  class="mr-7"
                  label="${translateFn('Any')}"
                  .value=${ExchangeRuleScopeEmailSelection.ANY}
                ></gz-radio>
                <gz-radio
                  label="${translateFn('Specific')}"
                  .value=${ExchangeRuleScopeEmailSelection.SPECIFIC}
                ></gz-radio>
              </gz-radio-group>
              <gz-input-error></gz-input-error>
            </gz-form-field>
          </gz-labeled-content>
          <gz-text
            id="rule-scope-to-description"
            fontSize="${FontSizes.PARAGRAPH_12}"
            fontWeight="${FontWeights.NORMAL}"
            class="infoText"
            .innerHTML=${translateFn(
              'By default, the rule applies to all recipients. To apply different filtering settings and actions for certain sender groups, select {bold}Specific{/bold} and add a custom rule.',
              {
                bold: '<strong>',
                '/bold': '</strong>',
              }
            )}
          ></gz-text>

          <gz-form-field id="rule-scope-to-specific-field" class="mt-2 hidden">
            <gz-policy-panel-exchange-user-groups-grid gz-form-input></gz-policy-panel-exchange-user-groups-grid>
            <gz-input-error></gz-input-error>
          </gz-form-field>

          <gz-form-field id="rule-scope-match-all-recipients-field" class="hidden pb-2">
            <gz-checkbox label="${translateFn('Match all recipients')}" gz-form-input></gz-checkbox>
          </gz-form-field>
        </div>
        <gz-title fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.HEADING_4}" class="module-subtitle"
          >${translateFn('Settings')}</gz-title
        >
        <gz-title fontSize="${FontSizes.PARAGRAPH_11}" fontWeight="${FontWeights.SEMIBOLD}" class="form-subtitle"
          >${translateFn('Aggressivity')}</gz-title
        >
        <gz-form-field id="aggressivity-field">
          <gz-selection-card-group gz-form-input>
            <gz-selection-card
              label="${getExchangeAntispamAggressivity(ExchangeAntispamAggressivity.AGGRESSIVE)}"
              .value="${ExchangeAntispamAggressivity.AGGRESSIVE}"
              .id="${'aggressivity-aggressive'}"
            >
              <div slot="content">
                <gz-title fontSize="12" fontWeight="600" style="margin-bottom: 8px"
                  >${translateFn('Recommended for critical systems')}</gz-title
                >
                <gz-text fontSize="12" style="margin-bottom: 8px"
                  >${translateFn(
                    'This option eliminates most spam, but it may produce false positives. Use on workstations only if you receive very high volumes of spam. '
                  )}</gz-text
                >
              </div>
            </gz-selection-card>
            <gz-selection-card
              label="${getExchangeAntispamAggressivity(ExchangeAntispamAggressivity.NORMAL)}"
              .value="${ExchangeAntispamAggressivity.NORMAL}"
              .id="${'aggressivity-normal'}"
            >
              <div slot="content">
                <gz-title fontSize="12" fontWeight="600" style="margin-bottom: 8px"
                  >${translateFn('Recommended for most systems')}</gz-title
                >
                <gz-text fontSize="12" style="margin-bottom: 8px"
                  >${translateFn(
                    'This is the default setting. It blocks most spam, while avoiding false positives.'
                  )}</gz-text
                >
              </div>
            </gz-selection-card>
            <gz-selection-card
              label="${getExchangeAntispamAggressivity(ExchangeAntispamAggressivity.PERMISSIVE)}"
              .value="${ExchangeAntispamAggressivity.PERMISSIVE}"
              .id="${'aggressivity-permissive'}"
            >
              <div slot="content">
                <gz-title fontSize="12" fontWeight="600" style="margin-bottom: 8px"
                  >${translateFn('Not recommended')}</gz-title
                >
                <gz-text fontSize="12" style="margin-bottom: 8px"
                  >${translateFn(
                    'This option will let most email through. Recommended only if you receive a lot of commercial email. May produce false negatives.'
                  )}</gz-text
                >
              </div>
            </gz-selection-card>
          </gz-selection-card-group>
        </gz-form-field>

        <!-- Filters section -->
        <gz-title fontSize="${FontSizes.PARAGRAPH_11}" fontWeight="${FontWeights.SEMIBOLD}" class="form-subtitle"
          >${translateFn('Filters')}</gz-title
        >
        <gz-form-field id="asian-field">
          <gz-tooltip tooltipText="${translateFn('Detects as spam email messages that contain Asian characters.')}">
            <gz-checkbox label="${translateFn('Asian')}" gz-form-input></gz-checkbox>
          </gz-tooltip>
        </gz-form-field>

        <gz-form-field id="cyrilic-field">
          <gz-tooltip tooltipText="${translateFn('Detects as spam email messages that contain Cyrillic characters.')}">
            <gz-checkbox label="${translateFn('Cyrillic')}" gz-form-input></gz-checkbox>
          </gz-tooltip>
        </gz-form-field>

        <gz-form-field id="fapMaterial-field">
          <gz-tooltip
            tooltipText="${translateFn(
              "Detects as spam email messages tagged 'Sexually-explicit' in the subject line."
            )}"
          >
            <gz-checkbox label="${translateFn('Sexually-explicit content')}" gz-form-input checked></gz-checkbox>
          </gz-tooltip>
        </gz-form-field>

        <gz-form-field id="url-field">
          <gz-tooltip
            tooltipText="${translateFn(
              'Detects as spam email messages that contain URLs present in the Bitdefender antispam URL blocklist.'
            )}"
          >
            <gz-checkbox label="${translateFn('URL')}" gz-form-input checked></gz-checkbox>
          </gz-tooltip>
        </gz-form-field>
        <gz-form-field id="rbl-field">
          <gz-tooltip
            tooltipText="${translateFn(
              "Queries the RBL servers defined in the Antispam Filtering settings to assess the sender's mail server spammer reputation."
            )}"
          >
            <gz-checkbox label="${translateFn('Real-time Blackhole List (RBL)')}" gz-form-input></gz-checkbox>
          </gz-tooltip>
        </gz-form-field>
        <gz-form-field id="heuristic-field">
          <gz-tooltip
            tooltipText="${translateFn(
              'The advanced heuristic antispam filter developed by Bitdefender detects new and unknown spam by looking for spam characteristics. This filter is designed to improve signature-based detection, while keeping the number of false positives very low.'
            )}"
          >
            <gz-checkbox label="${translateFn('Heuristic')}" gz-form-input checked></gz-checkbox>
          </gz-tooltip>
        </gz-form-field>

        <gz-form-field id="cloud-field">
          <gz-tooltip
            tooltipText="${translateFn('Queries the Bitdefender Cloud services to improve zero-day spam detection.')}"
          >
            <gz-checkbox label="${translateFn('Cloud')}" gz-form-input checked></gz-checkbox>
          </gz-tooltip>
        </gz-form-field>

        <gz-title
          fontSize="${FontSizes.PARAGRAPH_11}"
          fontWeight="${FontWeights.SEMIBOLD}"
          class="options-form-subtitle"
          >${translateFn('Options')}</gz-title
        >
        <gz-form-field id="auth-connections-check-field">
          <gz-checkbox label="${translateFn('Check authenticated connections')}" gz-form-input></gz-checkbox>
        </gz-form-field>

        <!-- Actions section-->
        <div id="rules-actions-section">
          <gz-title fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.HEADING_4}" class="module-subtitle mt-5"
            >${translateFn('Actions')}</gz-title
          >
          <gz-title fontWeight="${FontWeights.NORMAL}" fontSize="${FontSizes.HEADING_6}" class="action-title mt-3"
            >${translateFn('Primary action')}</gz-title
          >

          <div id="rule-actions-primary-section">
            <gz-form-field id="rule-actions-type-field" no-impact>
              <gz-dropdown
                gz-form-input
                label="${translateFn('Action')}"
                .options=${getExchangeAntispamActionRuleFormOptions()}
                @optionSelected="${this.handleActionsTypeFieldChange}"
              ></gz-dropdown>
            </gz-form-field>

            <gz-form-field id="rule-actions-deliver-to-field" class="hidden" disabled>
              <gz-input
                gz-form-input
                inputWidth="${InputWidthValues.LARGE}"
                placeholder="${translateFn('Enter the email address')}"
              ></gz-input>
            </gz-form-field>
          </div>

          <div id="rule-actions-secondary-section">
            <gz-title fontWeight="${FontWeights.NORMAL}" fontSize="${FontSizes.HEADING_6}"
              >${translateFn('Secondary actions')}</gz-title
            >

            <!-- Rule actions section: Tag the email subject as -->
            <gz-form-field id="exchange-scl-field">
              <gz-checkbox label="${translateFn('Integrate with Exchange SCL')}" gz-form-input></gz-checkbox>
            </gz-form-field>
            <div class="checkbox-with-input">
              <gz-form-field class="checkbox-width-220" id="rule-actions-modify-subject-field">
                <gz-checkbox
                  id="rule-actions-modify-subject-checkbox"
                  label="${translateFn('Tag the email subject as')}"
                  gz-form-input
                  @change="${e => this.toggleDisabledField(this.ruleActionsModifySubjectTextField, !e.detail.checked)}"
                ></gz-checkbox>
              </gz-form-field>

              <gz-form-field id="rule-actions-modify-subject-text-field" disabled>
                <gz-input
                  gz-form-input
                  inputWidth="${InputWidthValues.LARGE}"
                  placeholder="${translateFn('Enter a label')}"
                ></gz-input>
              </gz-form-field>
            </div>

            <!-- Rule actions section: Email header -->
            <div>
              <gz-form-field class="checkbox-width-220" id="rule-actions-append-header-field">
                <gz-checkbox
                  label="${translateFn('Add an email header')}"
                  gz-form-input
                  @change="${e => this.toggleActionsAppendHeaderFieldDisabledState(!e.detail.checked)}"
                ></gz-checkbox>
              </gz-form-field>

              <gz-form-field
                class="hidden helper-text"
                id="rule-actions-append-header-name-field"
                label="${translateFn('Header name')}"
                disabled
              >
                <gz-input
                  gz-form-input
                  inputWidth="${InputWidthValues.LARGE}"
                  placeholder="${translateFn('Enter a name')}"
                ></gz-input>
              </gz-form-field>

              <gz-form-field
                class="hidden helper-text"
                id="rule-actions-append-header-value-field"
                label="${translateFn('Header value')}"
                disabled
              >
                <gz-input
                  gz-form-input
                  inputWidth="${InputWidthValues.LARGE}"
                  placeholder="${translateFn('Enter a value')}"
                ></gz-input>
              </gz-form-field>
            </div>

            <!-- Rule actions section: Save email to disk -->
            <div class="checkbox-with-input">
              <gz-form-field class="checkbox-width-220" id="rule-actions-save-mail-to-disk-field">
                <gz-checkbox
                  label="${translateFn('Save email to disk')}"
                  gz-form-input
                  @change="${e => this.toggleDisabledField(this.ruleActionsSaveMailToDiskPathField, !e.detail.checked)}"
                ></gz-checkbox>
              </gz-form-field>

              <gz-form-field id="rule-actions-save-mail-to-disk-path-field" disabled>
                <gz-input
                  gz-form-input
                  inputWidth="${InputWidthValues.LARGE}"
                  placeholder="${translateFn('Enter the full path')}"
                ></gz-input>
              </gz-form-field>
            </div>

            <!-- Rule actions section: Archive to account -->
            <div class="checkbox-with-input">
              <gz-form-field class="checkbox-width-220" id="rule-actions-archive-to-account-field">
                <gz-checkbox
                  label="${translateFn('Archive to account')}"
                  gz-form-input
                  @change="${e =>
                    this.toggleDisabledField(this.ruleActionsArchiveToAccountAddressField, !e.detail.checked)}"
                ></gz-checkbox>
              </gz-form-field>

              <gz-form-field id="rule-actions-archive-to-account-address-field" disabled>
                <gz-input
                  gz-form-input
                  inputWidth="${InputWidthValues.LARGE}"
                  placeholder="${translateFn('Enter the email archive address')}"
                ></gz-input>
              </gz-form-field>
            </div>

            <!-- Rule actions section: Notify section -->
            <div id="rules-actions-notify-section" class="hidden">
              <gz-form-field id="rule-actions-notify-recipient-field" disabled>
                <gz-checkbox label="${translateFn('Notify the recipient')}" gz-form-input></gz-checkbox>
              </gz-form-field>
              <gz-text
                id="rule-actions-notify-recipient-text"
                fontSize="${FontSizes.PARAGRAPH_12}"
                fontWeight="${FontWeights.NORMAL}"
                class="infoText helper-text"
                >${translateFn(
                  'Send a notification to the intended recipients when an action is taken on an email. Emails are sent only to mailboxes on domains accepted by the company email server.'
                )}
              </gz-text>

              <gz-form-field id="rule-actions-notify-sender-field" disabled>
                <gz-checkbox label="${translateFn('Notify the sender')}" gz-form-input></gz-checkbox>
              </gz-form-field>
              <gz-text
                id="rule-actions-notify-sender-text"
                fontSize="${FontSizes.PARAGRAPH_12}"
                fontWeight="${FontWeights.NORMAL}"
                class="infoText helper-text"
                >${translateFn(
                  'Send notification to the sender when an action is taken on an email. Emails are only sent to mailboxes that belong to a domain accepted by the company email server.'
                )}
              </gz-text>

              <div class="checkbox-with-input">
                <gz-form-field class="checkbox-width-220" id="rule-actions-notify-account-field" disabled>
                  <gz-checkbox
                    label="${translateFn('Notify the user')}"
                    gz-form-input
                    @change="${e =>
                      this.toggleDisabledField(this.ruleActionsNotifyAccountRecipientsField, !e.detail.checked)}"
                  ></gz-checkbox>
                </gz-form-field>

                <gz-form-field id="rule-actions-notify-account-recipients-field" disabled>
                  <gz-input
                    gz-form-input
                    inputWidth="${InputWidthValues.LARGE}"
                    placeholder="${translateFn('Enter the email address')}"
                  ></gz-input>
                </gz-form-field>
              </div>
              <gz-text
                id="rule-actions-notify-account-text"
                fontSize="${FontSizes.PARAGRAPH_12}"
                fontWeight="${FontWeights.NORMAL}"
                class="infoText helper-text"
                >${translateFn('Send notification to the specified mailboxes when an action is taken on an email.')}
              </gz-text>
            </div>
          </div>

          <gz-form-field id="rule-actions-stop-if-matched-field">
            <gz-checkbox label="${translateFn('Stop processing more rules')}" gz-form-input checked></gz-checkbox>
          </gz-form-field>
        </div>
      </div>
    `;
  }

  protected setFormGroupValue(): void {
    if (!this.value) {
      this.rulePriority.value = 1; // by default, a new rule will be added at the top of the list
      this.aggressivityField.value = ExchangeAntispamAggressivity.NORMAL;
      this.ruleActionsTypeField.value = ExchangeAntispamRuleActionType.DELIVER;
      this.ruleActionsModifySubjectField.value = true;
      this.ruleActionsModifySubjectTextField.value = '[SPAM]';
      this.rulesActionsExchangeSclField.value = true;
      return;
    }

    this.formGroup.value = {
      defaultPositionInGrid: this.value.defaultPositionInGrid,
      name: this.value.name,
      active: this.value.active,
      default: this.value.default,
      scope: this.value.scope,
      aggressivity: this.value.aggressivity,
      filters: this.value.filters,
      checkAuthConnections: this.value.checkAuthConnections,
      actions: this.value.actions,
    };

    // change disabled and visibility of fields based on default state
    toggleDisabled(this.ruleName, this.value.default);
    toggleDisabled(this.rulePriority, this.value.default);
    toggleDisabled(this.activeFormField, this.value.default);
    toggleDisabled(this.ruleScopeApplyToField, this.value.default);
    toggleDisabled(this.ruleScopeFromField, this.value.default);
    toggleDisabled(this.ruleScopeToField, this.value.default);
  }

  private handleScopeFromEmailSelectionChange(event: CustomEvent) {
    const isSpecific = event.detail.selectedValue === ExchangeRuleScopeEmailSelection.SPECIFIC;

    // show/hide user groups grid
    toggleVisibility(this.ruleScopeFromSpecificField, isSpecific);
    this.ruleScopeFromSpecificField.Validators = isSpecific ? ruleScopeSpecificValidators() : [];
    this.ruleScopeFromSpecificField.touched = isSpecific;
  }

  private handleScopeToEmailSelectionChange(event: CustomEvent) {
    const isSpecific = event.detail.selectedValue === ExchangeRuleScopeEmailSelection.SPECIFIC;

    // show/hide user groups grid
    toggleVisibility(this.ruleScopeToSpecificField, isSpecific);
    this.ruleScopeToSpecificField.Validators = isSpecific ? ruleScopeSpecificValidators() : [];
    this.ruleScopeToSpecificField.touched = isSpecific;

    // show/hide match all recipients
    toggleVisibility(this.ruleScopeMatchAllRecipientsField, isSpecific);
  }

  private handleActionsTypeFieldChange(event: CustomEvent) {
    // for the first change, values from backend are used for secondary actions
    if (!this.ruleActionsTypeField.hasAttribute('no-impact')) {
      this.ruleActionsDeliverToField.value = '';
      this.ruleActionsModifySubjectField.value = false;
      this.ruleActionsModifySubjectTextField.value = '';
      this.rulesActionsExchangeSclField.value = false;
      this.ruleActionsAppendHeaderField.value = false;
      this.ruleActionsAppendHeaderNameField.value = '';
      this.ruleActionsAppendHeaderValueField.value = '';
      this.ruleActionsSaveMailToDiskField.value = false;
      this.ruleActionsSaveMailToDiskPathField.value = '';
      this.ruleActionsArchiveToAccountField.value = false;
      this.ruleActionsArchiveToAccountAddressField.value = '';
      this.ruleActionsStopIfMatchedField.value = true;
      this.ruleActionsNotifyRecipientField.value = false;
      this.ruleActionsNotifySenderField.value = false;
      this.ruleActionsNotifyAccountField.value = false;
      this.ruleActionsNotifyAccountRecipientsField.value = '';
    } else {
      this.ruleActionsTypeField.removeAttribute('no-impact');
    }

    // show/hide deliver to field & disable it
    const toggleDeliverToVisibility = (isVisible: boolean) => {
      toggleVisibility(this.ruleActionsDeliverToField, isVisible);
      this.toggleDisabledField(this.ruleActionsDeliverToField, !isVisible);
    };

    const toggleExchangeSclVisibility = (isVisible: boolean) => {
      toggleVisibility(this.rulesActionsExchangeSclField, isVisible);
      this.rulesActionsExchangeSclField.disabled = !isVisible;
    };

    // show/hide modify subject fields & disable it
    const toggleModifySubjectVisibility = (isVisible: boolean) => {
      toggleVisibility(this.ruleActionsModifySubjectField, isVisible);
      this.ruleActionsModifySubjectField.disabled = !isVisible;
      toggleVisibility(this.ruleActionsModifySubjectTextField, isVisible);
      this.toggleDisabledField(
        this.ruleActionsModifySubjectTextField,
        !isVisible || !this.ruleActionsModifySubjectField.value
      );
    };
    // show/hide archive to account fields & disable it
    const toggleArchiveToAccountVisibility = (isVisible: boolean) => {
      toggleVisibility(this.ruleActionsArchiveToAccountField, isVisible);
      this.ruleActionsArchiveToAccountField.disabled = !isVisible;
      toggleVisibility(this.ruleActionsArchiveToAccountAddressField, isVisible);
      this.toggleDisabledField(
        this.ruleActionsArchiveToAccountAddressField,
        !isVisible || !this.ruleActionsArchiveToAccountField.value
      );
    };

    // show/hide append header fields & disable it
    const toggleAppendHeaderFieldVisibility = (isVisible: boolean) => {
      toggleVisibility(this.ruleActionsAppendHeaderField, isVisible);
      this.ruleActionsAppendHeaderField.disabled = !isVisible;
      this.toggleActionsAppendHeaderFieldDisabledState(!isVisible || !this.ruleActionsAppendHeaderField.value);
    };
    // show notify section
    const toggleNotifySectionVisibility = (isVisible: boolean) => {
      toggleVisibility(this.ruleActionsNotifySection, isVisible);
      this.ruleActionsNotifyRecipientField.disabled = !isVisible;
      this.ruleActionsNotifySenderField.disabled = !isVisible;
      this.ruleActionsNotifyAccountField.disabled = !isVisible;
      this.toggleDisabledField(
        this.ruleActionsNotifyAccountRecipientsField,
        !isVisible || !this.ruleActionsNotifyAccountField.value
      );
    };

    switch (event.detail.newValue.value) {
      case ExchangeAntispamRuleActionType.QUARANTINE:
      case ExchangeAntispamRuleActionType.REJECT:
        toggleExchangeSclVisibility(false);
        toggleDeliverToVisibility(false);
        toggleModifySubjectVisibility(false);
        toggleArchiveToAccountVisibility(false);
        toggleAppendHeaderFieldVisibility(false);
        toggleNotifySectionVisibility(true);
        break;
      case ExchangeAntispamRuleActionType.REDIRECT:
        toggleExchangeSclVisibility(true);
        toggleDeliverToVisibility(true);
        toggleModifySubjectVisibility(true);
        toggleArchiveToAccountVisibility(true);
        toggleAppendHeaderFieldVisibility(true);
        toggleNotifySectionVisibility(true);
        break;
      default:
        toggleExchangeSclVisibility(true);
        toggleDeliverToVisibility(false);
        toggleModifySubjectVisibility(true);
        toggleArchiveToAccountVisibility(true);
        toggleAppendHeaderFieldVisibility(true);
        toggleNotifySectionVisibility(false);
        break;
    }
  }

  /**
   * Toggle disabled state of the field.
   * @param field
   * @param disabled
   * @private
   */
  private toggleDisabledField(field: GzFormFieldWebComponent, disabled: boolean) {
    field.disabled = disabled;

    if (disabled) {
      field.resetField();
    } else {
      field.validate(true);
    }
  }

  /**
   * Toggle disabled state of the append header fields.
   * @param disabled
   * @private
   */
  private toggleActionsAppendHeaderFieldDisabledState(disabled: boolean) {
    this.toggleDisabledField(this.ruleActionsAppendHeaderNameField, disabled);
    this.toggleDisabledField(this.ruleActionsAppendHeaderValueField, disabled);
    toggleVisibility(this.ruleActionsAppendHeaderNameField, !disabled);
    toggleVisibility(this.ruleActionsAppendHeaderValueField, !disabled);
  }
}
function validateRuleName(value: string, ruleNames: string[]): ValidationResult {
  if (ruleNames.includes(value)) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }
  return { valid: true };
}
